import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { ReportDto } from "../types/report";

export default function marketingLinkSummaryReportReducer(
  state: ReportDto = initialState.marketingLinkSummaryReport,
  action: AnyAction
): ReportDto {
  switch (action.type) {
    case internalActionKeys.GET_MARKETING_LINK_SUMMARY_REPORT_SUCCESS:
      return action.report;
    default:
      return state;
  }
}
